import './Page.scss';

import { b2x } from '@b2x/react/src';
import classnames from 'classnames';
import React from 'react';

import { useAppStaticContext } from '../AppContext';

export interface PageProps extends b2x.PageProps {
  backgroundAsset?: b2x.contentTypes.AssetAsBackgroundContentSectionV2;
  backgroundSize?: string;
  footerCheckout?: boolean;
  grayBackground?: boolean;
  headerCheckout?: boolean;
  noPaddingBottom?: boolean;
  noPaddingTop?: boolean;
  pageWrapperClassName?: string;
}

export const Page = ({
  backgroundAsset,
  backgroundSize,
  children,
  className,
  footerCheckout = false,
  grayBackground = false,
  headerCheckout = false,
  noPaddingBottom,
  noPaddingTop,
  pageWrapperClassName,
  ...otherProps
}: PageProps) => {
  const { pageReady } = b2x.useAppContext();
  const { setFooterCheckout, setHeaderCheckout } = useAppStaticContext();

  React.useEffect(() => {
    pageReady && setHeaderCheckout(headerCheckout);
    pageReady && setFooterCheckout(footerCheckout);
  }, [pageReady, headerCheckout, footerCheckout, setHeaderCheckout, setFooterCheckout, grayBackground]);

  const _backgroundSize = (backgroundSize ?? 'contain') as 'initial' | 'cover' | 'contain' | undefined;

  return (
    <b2x.Page {...otherProps} className={classnames(className, 'h-100', { 'bg-gray-100': grayBackground })}>
      <div className={classnames('page h-100 position-relative d-grid')} id="main-content" role="main">
        {backgroundAsset && (
          <div
            className={classnames('page-background-container', `background-type-${_backgroundSize}`)}
            style={{ gridColumn: '1', gridRow: '1' }}
          >
            <b2x.AssetAsBackgroundV2 {...backgroundAsset} backgroundSize={_backgroundSize} />
          </div>
        )}
        <div
          className={classnames(
            'position-relative h-100 page-inner-container',
            { 'pb-5': !noPaddingBottom },
            { 'pt-3 pt-xl-5': !noPaddingTop },
            { 'bg-gray-100': grayBackground }
          )}
          style={{
            gridColumn: '1',
            gridRow: '1',
            minWidth: '100%',
            width: '100%',
          }}
        >
          {children}
        </div>
      </div>
    </b2x.Page>
  );
};
